import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import contactdata from "../../gramdata/ContactUs";
// import Axios from "axios";

import { useHistory } from "react-router-dom";
import UseMobile from "../../hooks/useIsMobile";
import {
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@material-ui/core";
import { Tabular } from "../../GramLayouts";
import { useSelector } from "react-redux";
import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../../components/Loading/LoadingComponet";

const useStyles = makeStyles((theme) => ({
  root: {
    // padding: "3vh 0vw",
    width: "50vw",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  tableContainer: {
    marginTop: theme.spacing(-2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(-1),
    },
  },
  cardBody: {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
  loadingContainer: {
    height: "50vh",
    width: "50vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const GramSchemesLayout = () => {
  const classes = useStyles();
  const history = useHistory();

  const renderItem = (title, info) => {
    return (
      <Grid item container lg={12} md={12} sm={12} xs={12} direction="column">
        <Grid item>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">{info}</Typography>
        </Grid>
      </Grid>
    );
  };

  const isMobile = UseMobile();
  const gramId = useSelector((state) => state.util.currentGramId);
  const { ready, data, error } = GetPageData(`gramContact/${gramId}`);
  return ready && data ? (
    <div className={classes.root}>
      <Grid container>
        {renderItem(data.gramText, data.gram)}
        {renderItem(data.addressText, data.address)}
      </Grid>
      <div className={classes.tableContainer}>
        <Tabular data={data?.data[0]} />
      </div>
    </div>
  ) : (
    <div className={classes.loadingContainer}>
      <CircularProgress size={20} color="primary" />
    </div>
  );
};
export default GramSchemesLayout;
